import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  TableHead,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import paper from "../../../image/paper.svg";
import paper2 from "../../../image/paper2.svg";
import pdf from "../../../image/pdf.svg";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {

  },
  tableContainer: {
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
  },
  tableHead: {
    backgroundColor: "#FFF6E1",
  },
  tableCell: {
    fontWeight: "bold",
    // textAlign: "center", // Centers text horizontally
  },
  cellContent: {
    display: "flex",
    alignItems: "center", // Centers icon and text vertically
    // justifyContent: "center", // Centers content horizontally
    gap: "10px", // Adds space between icon and text
  },
  icon: {
    background: "white",
    borderRadius: "50%",
    height: "40px",
    width: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  downloadLinkWrapper: {
    textAlign: "center",
    borderLeft: "1px solid gray",
  },
  downloadLink: {
    display: "flex",
    alignItems: "center", // Ensures text and icon are aligned
    justifyContent: "center", // Centers them inside the cell
    gap: "10px",
    color: theme.palette.primary.main,
    textDecoration: "none",
    whiteSpace: "nowrap",
  },
}));

const PreviousYearPapers = ({ previousyearpaperDetail }) => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      {previousyearpaperDetail.pdf_papers && (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>
                  <div className={classes.cellContent}>
                    <span className={classes.icon}>
                      <img src={paper} height={20} alt="paper" />
                    </span>
                    SSC CGL Previous Year Question Papers (Tier 1)
                  </div>
                </TableCell>
                <TableCell align="center" className={classes.tableCell}>
                  <div className={classes.cellContent}>
                    <span className={classes.icon}>
                      <img src={paper2} height={20} alt="paper" />
                    </span>
                    Download Link
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {previousyearpaperDetail.pdf_papers.map((paper) => (
                <TableRow key={paper.id}>
                  <TableCell>
                    <div
                      className={{
                        ...classes.cellContent,
                        justifyContent: "start",
                      }}
                    >
                      {paper.previous_year_paper_name}
                    </div>
                  </TableCell>
                  {paper.payment_status === "free" && paper.type === "pdf" ? (
                    <TableCell
                      className={classes.downloadLinkWrapper}
                      style={{ cursor: "pointer" }}
                    >
                      <Link
                        target="_blank"
                      to={paper.pdf_url} className={classes.downloadLink}>
                        Download Here
                        <img src={pdf} height={20} alt="pdf" />
                      </Link>
                    </TableCell>
                  ) : (
                    <TableCell
                      className={classes.downloadLinkWrapper}
                      style={{ cursor: "not-allowed", opacity: "0.5" }}
                    >
                      <Link
                        className={classes.downloadLink}
                        style={{ color: "gray", textDecoration: "none" }}
                      >
                        Download Here
                        <img src={pdf} height={20} alt="pdf" />
                      </Link>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default PreviousYearPapers;
